


















import Vue from 'vue';
import DvFilterPopover from '@/components/util/DvFilterPopover.vue';
import { SkillType } from '@/models/skills/SkillEnums';
import { skillTypeName } from '@/helpers/SkillEnumNames';

interface IEntry {
    id: number;
    label: string;
}

const ENTRIES: IEntry[] = [
    SkillType.ACTIVE,
    SkillType.PASSIVE,
    SkillType.AUTOMATIC_PASSIVE,
    SkillType.EX_PASSIVE,
    SkillType.AUTOMATIC_ACTIVATION,
].map((id) => ({ id, label: skillTypeName(id) }));

export default Vue.extend({
    components: { DvFilterPopover },
    props: {
        //  Controlled component: the parent owns the selection and the URL.
        //  This deliberately diverges from the older item-search selectors
        //  (ItemSearchTypeSelector and siblings), which are $route-driven,
        //  start with everything ticked, and carry a skipCompute guard
        //  against an infinite URL ping-pong. Here nothing ticked simply
        //  means no filter, and there is no ping-pong to guard against
        //  because SkillSearch.created() seeds the filter (from the URL)
        //  before any child mounts, so this component's first @select can
        //  never race that seed. The other four skill selectors were
        //  patterned on this one and follow the same idiom.
        value: { type: Array as () => number[], default: () => [] },
    },
    computed: {
        entries(): IEntry[] {
            return ENTRIES;
        },
    },
    methods: {
        toggle(id: number, checked: boolean) {
            const set = new Set(this.value);
            if (checked) {
                set.add(id);
            } else {
                set.delete(id);
            }
            this.$emit('select', [...set].sort((a, b) => a - b));
        },
        emitAll() {
            this.$emit('select', ENTRIES.map((e) => e.id));
        },
    },
});
